var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCounterclockwiseCircularArrow = function SvgCounterclockwiseCircularArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9212 2.40744C29.4264 1.90229 30 1.45803 30 0.940673C30 0.42332 29.5801 0.00341797 29.0628 0.00341797H19.6904C19.5771 0.00341797 18.7532 0.00341797 18.7532 0.940673V10.313C18.7532 10.8304 19.173 11.2503 19.6904 11.2503C20.2078 11.2503 20.5696 10.7601 20.9688 10.3599L23.5734 7.75528C25.2323 9.71131 26.2426 12.2344 26.2426 15.0011C26.2426 21.2121 21.2069 26.248 14.9958 26.248C8.78466 26.248 3.74897 21.2122 3.74897 15.0011C3.74897 9.43018 7.80436 4.81709 13.1213 3.92298V0.134643C5.72652 1.05969 0 7.35513 0 15.0011C0 23.2835 6.71343 29.9968 14.9958 29.9968C23.2781 29.9968 29.9916 23.2834 29.9916 15.0011C29.9916 11.1988 28.5707 7.73288 26.2361 5.09263L28.9212 2.40744Z",
    fill: "#979797"
  })));
};

export default __webpack_public_path__ + "static/media/counterclockwise-circular-arrow.db9bcd3d.svg";
export { SvgCounterclockwiseCircularArrow as ReactComponent };